module.exports = __webpack_public_path__ + "img/40_56.ad489595.png";